import {toastService} from "../../../libraries/toast";
import {menstrualCycleModel} from "../entity/MenstrualCycleModel";
import {menstrualCycleService} from "../entity/MenstrualCycleService";

export const getMenstrualCycleUseCase = async (recommended_type: string) => {
    try {
        const response = await menstrualCycleService.get({ recommended_type });
        if (response?.isError) {
            toastService.onError('Some error');
        } else {
            menstrualCycleModel.menstrualCycle = response.data.rows;
            return response.data?.rows;
        }
    } catch (error) {
        console.error('getMenstrualCycleUseCase: ', error);
    }
}